<template>
<div class="focuseprak " >
	<leftnav class="fl" :openmeunclass='5' :title="title" :curindex="7" :openmeun="true"></leftnav>
	<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
		<govheader></govheader>
		<div class="index_left_centerpage"> 
		<div class="whitebox right_topbox">
			<div class="right_boxtitle">
				<span class="fl right_title">关注园区</span>
				<div><span class="focusenterprises_num">截止目前您已关注园区<span class="orangefont ">{{parkdata.length}}</span>家</span> </div>
			</div>  
			<div class="enterprise_list_box">
				<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table focuseprak_table" v-if="parkdata.length>0"	>
					<tr>
						<th class="xuhaotd">序号</th>
						<th class="">园区名称</th>
						<th>省份</th>
						<th>城市</th>
						<th>地区</th>
						<!-- <th>约面积（亩）</th> -->
						<!-- <th>企业数</th> -->
						<th>关注时间<!-- <i class="sort_ico" @click="tablesort(1)"> </i> --></th>
						<th>关注</th>
					</tr>
					 <tr v-for="(item,i) in parkdata">
					 	<td>{{i+1}}</td>
					 	<td class="indust_parkname" @click="detailrouterto('/industrialparkDetail',item.id)">{{item.parkName}}</td>
					 	<td>{{item.areaText.substring(0,3)}}</td>
					 	<td>
								<span v-if="item.areaText.substring(3,6) !=''">{{item.areaText.substring(3,6)}}</span>
									<span v-if="item.areaText.substring(3,6) ==''">-</span>
									</td>
					 	<td>
									<span v-if="item.areaText.substring(6,9) !=''">{{item.areaText.substring(6,9)}}</span>
									<span v-if="item.areaText.substring(6,9) ==''">-</span>
									</td>
					 	<!-- <td>{{item.area}}</td> -->
							<!-- <td>{{item.num}}</td> -->
							<td>{{item.collectTime}}</td>
							<td class="bluefont cancel" @click="cancelcollect(item.collectType,item.collectId)">取消</td>
					 </tr>  
				</table>
			<!-- 	<el-table
				    :data="tableData"
				    style="width: 100%"
				    :default-sort = "{prop: 'date', order: 'descending'}"
				    >
				    <el-table-column
				      prop="date"
				      label="日期"
				      sortable
				      width="180">
				    </el-table-column>
				    <el-table-column
				      prop="name"
				      label="姓名"
				      sortable
				      width="180">
				    </el-table-column>
				    <el-table-column
				      prop="address"
				      label="地址"
				      :formatter="formatter">
				    </el-table-column>
				  </el-table> -->
			</div>
			
		</div>
		</div>
	</div>
</div>
</template>

<script>
	export default {
	  name: 'focuseprak',
			data(){return{ 
				userdata:{},title:"关注园区",
					parkdata:[  {areaText:''} ],
					orderField:0,//排序字段 0 分数 1 时间
					orderType:0,//排序方式 0 降序 1 升序
					orderType1:1,//排序方式 0 降序 1 升序
					orderType2:0,//排序方式 0 降序 1 升序    
			}}, 
			created(){
				this.$nextTick(() => {
				        // 禁用右键
				        document.oncontextmenu = new Function("event.returnValue=false");
				        // 禁用选择
				        document.onselectstart = new Function("event.returnValue=false");
				      });
			},
			mounted() {
				document.getElementById('app').style.background = "#f0f3f5";
				 this.userdata = this.getuseriformation();
					this.bus.$emit('loading', false);
					this.getcollectlist(12);
			},
			methods:{ 
				//获取收藏列表
						getcollectlist(type){ 
							var _this=this;
							_this.bus.$emit('loading', true);
							// var ajaxurl=this.$api.cyl.collect.list()+'?type='+type+'&pageSize=100&page=1';
							this.$axios.get(this.$api.cyl.collect.list()+'?type='+type+'&pageSize=100&page=1',{headers:{AuthToken:this.userdata.token}}).then(function(res){
								console.log(22222,res);
								if(res.data.success){  
										var enterlist=res.data.list||[];
										_this.bigenlist = res.data.list||[];
									if(type == 7){
										_this.chainlist=enterlist;
									}else if(type == 1 || type == 2 || type == 3 || type == 4){ 
										for(var i=0;i<enterlist.length;i++){
											enterlist[i].notionlist=_this.taglistfun(enterlist[i].notion,enterlist[i].notionCode);  
											enterlist[i].taglist=_this.taglistfun(enterlist[i].tag,enterlist[i].tagCode); 
												//创新企业专属
											if(type == 2  && enterlist[i].financingRound == null){
												enterlist[i].financingRound=[];
											}
										}
										if(type == 1){
											_this.bigenlist=enterlist;
										}else if(type == 2){
											_this.smenlist=enterlist;
										}else if(type == 3){
											_this.orglist=enterlist;
										}else if(type == 4){
											_this.academylist=enterlist;
										} 
									}else if(type == 6){  
										_this.topiclist=enterlist;
									}else if(type == 8){
										_this.eventchain=enterlist;
									}else if(type == 9){
										_this.policychain=enterlist;
									}else if(type ==12){
										_this.parkdata = enterlist||[]; 
									}
									_this.bus.$emit('loading', false);
								}else{ 
									
								} 
							}).catch(function (error) { 
								// 请求失败处理 console.log(error);
							}); 
							
						},
						//取消收藏
						cancelcollect(type,id){  
							var _this=this;   
							$.ajax({
								type:"POST",
								url:this.$api.cyl.collect.remove(),
								data:{collectId:id},
								headers:{AuthToken:this.userdata.token },
								success:function(res){ 
									console.log(res);
									if(res.success){
											 _this.removecollectlist(type,id);
												_this.getcollectlist(12);
									} 
								} 
							})   
						},
						//不同的type 不同列表删除
						removecollectlist(type,id){
							if(type == 1){
								this.bigenlist=this.bigenlist.filter(data=>{
									return data.collectId!=id;
								})
							}else if(type == 2){
								this.smenlist=this.smenlist.filter(data=>{
									return data.collectId!=id;
								})
							}else if(type == 3){
								this.orglist=this.orglist.filter(data=>{
									return data.collectId!=id;
								})
							}else if(type == 4){
								this.academylist=this.academylist.filter(data=>{
									return data.collectId!=id;
								})
							}else if(type == 6){
								this.topiclist=this.topiclist.filter(data=>{
									return data.collectId!=id;
								}) 
							}else if(type == 7){
								this.chainlist=this.chainlist.filter(data=>{
									return data.collectId!=id;
								})
							}else if(type == 8){
								this.eventchain=this.eventchain.filter(data=>{
									return data.colledtId!=id;
								})
							}else if(type == 9){
								this.policychain=this.policychain.filter(data=>{
									return data.colledtId!=id;
								})
							}else if(type == 12){
								this.parkdata=this.parkdata.filter(data=>{
									return data.colledtId!=id;
								})
							}
						},
							//园区详情跳转
								detailrouterto(path,id,code){
								let routeUrl = this.$router.resolve({
										path: path,query: {type:2,id:id,code:code}
								});
								window.open(routeUrl.href, '_blank');  
				}, 
					//时间/分数升降序
					tablesort(field){
						this.orderField = field;
						if(field == 1){
							this.orderType1 = Math.abs(this.orderType1 -1);this.orderType=this.orderType1; 
						}else{
							this.orderType2 = Math.abs(this.orderType2 -1);this.orderType=this.orderType2;
						};
						this.getcollectlist();
					},
				}, 
	}
</script>

<style> 
</style>
